<template>
  <div class="step progressbar row mb-4">
    <div class="col-lg-1"></div>
    <div class="col-lg-10">
      <div class="d-flex justify-content-between mt-5">
        <div
            class="step-indicator-outer"
            v-bind:class="getProgressbar.step0">
          <div class="pt-5 step-indicator"><p class="bodytext m-0"><b><span class="number">1.</span>
            {{ trans('sample_order_step1') }}</b></p></div>
        </div>
        <div
            class="step-indicator-outer"
            v-bind:class="getProgressbar.step1">
          <div class="pt-5 step-indicator"><p class="bodytext m-0"><b><span class="number">2.</span>
            {{ trans('sample_order_step2') }}</b></p></div>
        </div>
        <div
            class="step-indicator-outer"
            v-bind:class="getProgressbar.step2">
          <div class="pt-5 step-indicator"><p class="bodytext m-0"><b><span class="number">3.</span>
            {{ trans('sample_order_step3') }}</b></p></div>
        </div>
        <div
            class="step-indicator-outer last"
            v-bind:class="getProgressbar.step3">
          <div class="pt-5 step-indicator"><p class="bodytext m-0"><b><span class="number">4.</span>
            {{ trans('sample_order_step4') }}</b></p></div>
        </div>
      </div>
    </div>
    <div class="col-lg-1"></div>
  </div>
</template>


<script>

import { translate } from "@/service/translation.js";

export default {
  props: {
    progressbar: Object
  },
  watch: {
    progressbar: function(newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
    }
  },

  data: function () {
    return {
      progressbarLocal: {
        'step0': 'active',
        'step1': '',
        'step2': '',
        'step3': ''
      }
    }

  },

  mounted() {
    // this.data.progressbarLocal = this.progressbar;
  },
  methods: {
    trans(key) {
      return translate(key);
    }
  },
  computed : {
    getProgressbar: function (){
      if(typeof  this.progressbar != 'undefined'){
        return this.progressbar
      }else{
        return  this.progressbarLocal
      }
    }
  }


}
</script>

<style lang="less">
.progressbar {
  overflow: hidden;
  .step-indicator-outer {
    position: relative;
    width: 25%;
    &:before {
      background-color: #999999;
      content: '';
      width: 400px;
      height: 4px;
      display: block;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateY(-50%);
    }
    .step-indicator {
      position: relative;
      &:before {
        background-color: #999999;
        content: '';
        width: 12px;
        height: 12px;
        display: block;
        position: absolute;
        border-radius: 50%;
        left: 50%;
        top: 0;
        transform: translate(-50%, -50%);
        z-index: 10;
      }
      p{
        text-align: center;
      }
    }
  }
  .step-indicator-outer.last {
    &:before {
      background-color: white;
      width: 100%;
      pointer-events: none;
    }
  }
  .step-indicator-outer.passed {
    &:before {
      background-color: #e20019;
    }
    p {
      color: #e20019;
    }
    .step-indicator {
      &:before {
        background-color: #e20019;
        width: 30px;
        height: 30px;
        z-index: 20;
      }
      &:after {
        background-color: #ffffff;
        content: '';
        width: 12px;
        height: 12px;
        display: block;
        position: absolute;
        border-radius: 50%;
        left: 50%;
        top: 0;
        transform: translate(-50%, -50%);
        z-index: 30;
      }
    }
  }
  .step-indicator-outer.active {
    p {
      color: #e20019;
    }
    .step-indicator {
      &:before {
        background-color: #e20019;
        width: 42px;
        height: 42px;
        z-index: 20;
      }
      &:after {
        background-color: #ffffff;
        content: '';
        width: 12px;
        height: 12px;
        display: block;
        position: absolute;
        border-radius: 50%;
        left: 50%;
        top: 0;
        transform: translate(-50%, -50%);
        z-index: 30;
      }
    }
  }
}

@media screen and (max-width: 1279px) {

}

@media screen and (max-width: 959px) {
  .progressbar{
    span.number {
      display: block;
    }
    p.bodytext {
      line-height: 1;
      text-align: center;
    }
  }
}

@media screen and (max-width: 599px) {
  .progressbar{
    p.bodytext {
      text-align: center;
    }
  }
}
</style>
